import { useEffect } from 'react'
import { useLocation } from 'react-router'
import PropTypes from 'prop-types'
import { SET_DRAWER_STATE } from 'modules/App/types'
import { useDispatch } from 'react-redux'

const ScrollToTop = () => {
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch({ type: SET_DRAWER_STATE, payload: { opened: false } })
  }, [location.pathname])

  return null
}

ScrollToTop.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
}

export default ScrollToTop
